import { PeSignupState } from '../dashboard/dashboard/pe-type.enum';

export class PeSignupStatus {
  ewebextra: PeSignupState;
  omi: PeSignupState;
  patientNotifications: PeSignupState;
}
